import React from 'react';
interface HeroSectionProps {
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
}
export function HeroSection(_props: HeroSectionProps) {
  return <section className="w-full overflow-hidden bg-[#0B0B0B]" aria-label="NOIZA" data-id="element-2155" data-mp="34rdvjywuehj2">
      <img src="https://cdn.magicpatterns.com/uploads/9Nj7HNVVMbgP5K5hvCbGEs/ChatGPT_Image_24_jul_2026,_20_44_44.png" alt="NOIZA, tu restaurante inteligente" className="block h-auto w-full max-h-[78vh] object-cover object-center" data-id="element-2156" data-mp="2qtp7ki7hau9s" />
    </section>;
}